<div class="banner">
    <div class="banner-bg"></div>
    <div class="banner-caption">
        <div class="main-logo">
            <a href="/"></a>
        </div>
        <!--Banner alanındaki başvuru tarihleri alanı düzenlendi-->
        <!-- <div class="main-text"> 

            <p class="head">Başvuru Alımları</p>
            <p class="date">Tamamlandı</p>
            <p class="appeal-text">
            </p>

        </div> -->
    </div>
    <div class="banner-bottom">
        <div class="banner-bottom-left">
            <div class="sanat-logo"></div>
            <div class="kemer-country-logo"></div>
        </div>
        <!--Banner alanında eczacıbaşı logo yerine mesa logosu eklendi.-->
        <div class="banner-bottom-right">
            <p>Sponsor</p>
            <div class="mesa-logo"></div>
        </div>
    </div>
    <div class="appeal-button">
        <!-- <a href="/basvuru-bilgilendirme" >
                <span>Başvuru için tıklayınız</span>
                <i class="arrow-right"></i>
            </a> -->
    </div>
</div>